module.exports = __webpack_public_path__ + "img/bohrungen-3.91730554.png";